module.exports = __webpack_public_path__ + "resources/img/map_nhn_playhub_m.701b18326a6fa8b24edae595bfeb857a.jpg";